import React from 'react';
import { PackageCheck, Truck } from 'lucide-react';
export const DeliveryOptions = () => {
  return <div className="bg-primary/5 border-2 border-primary/15 rounded-3xl p-6 md:p-8" data-id="element-55" data-mp="126iu1i59hl3o">
      <h2 className="text-xl md:text-2xl font-display font-bold text-gray-900 text-center mb-2" data-id="element-56" data-mp="1gudksszplfe4">
        Dvije mogućnosti preuzimanja
      </h2>
      <p className="text-center text-gray-600 mb-6 max-w-2xl mx-auto" data-id="element-57" data-mp="1bw2cimp2bcy0">
        Odaberite što vam više odgovara — osobno preuzimanje ili dostava do vaše
        lokacije.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-58" data-mp="j7wrdyu3jlxn">
        <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm flex items-start gap-4" data-id="element-59" data-mp="x6o015q6wfee">
          <div className="w-12 h-12 rounded-2xl bg-green-100 flex items-center justify-center flex-shrink-0 text-green-600" data-id="element-60" data-mp="t5aznb5v94ev">
            <PackageCheck size={26} data-id="element-61" data-mp="28krx4ks2qjno" />
          </div>
          <div data-id="element-62" data-mp="28nnrjz4pqq7d">
            <h3 className="font-bold text-gray-900 mb-1" data-id="element-63" data-mp="24khof0cwdf54">Osobno preuzimanje</h3>
            <p className="text-sm text-gray-600 leading-relaxed" data-id="element-64" data-mp="24mkhxud9dqel">
              Sami preuzmete i vratite opremu —{' '}
              <span className="font-bold text-green-600" data-id="element-65" data-mp="2vm0h3braqlkx">bez naknade</span> za
              dostavu.
            </p>
          </div>
        </div>
        <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm flex items-start gap-4" data-id="element-66" data-mp="2zodgzjjd3p9s">
          <div className="w-12 h-12 rounded-2xl bg-primary/15 flex items-center justify-center flex-shrink-0 text-primary" data-id="element-67" data-mp="34m5ldd1713uv">
            <Truck size={26} data-id="element-68" data-mp="27uv18wlcvtam" />
          </div>
          <div data-id="element-69" data-mp="2bzb2ulnxsek1">
            <h3 className="font-bold text-gray-900 mb-1" data-id="element-70" data-mp="2byswuxbh2lyx">Dostava i postava</h3>
            <p className="text-sm text-gray-600 leading-relaxed" data-id="element-71" data-mp="2gwb8ivgvjfam">
              Dostavljamo i postavljamo na vašoj lokaciji. Cijena se{' '}
              <span className="font-bold text-primary" data-id="element-72" data-mp="2lq5rfwonnq8n">
                obračunava ovisno o udaljenosti
              </span>{' '}
              i potvrđuje prilikom dogovora.
            </p>
          </div>
        </div>
      </div>
    </div>;
};